module.exports = __webpack_public_path__ + "static/media/restaurante-fake.cd9dc0a0.png";